(function($){

	var lastScrollTop = 0;

	$(window).on('scroll',function(){
		var $site_header = $('#site-header');

		if($site_header.length && $(window).scrollTop() >= 50 && !$site_header.hasClass('scroll')) {
			$site_header.addClass('scroll');
		}

		if($site_header.length && $(window).scrollTop() < 50) {
			$site_header.removeClass('scroll');
		}

		if($(window).width() >= 992) {

			var st = $(this).scrollTop();

			if(st > 20) {
				if(st > lastScrollTop) {
					$('#site-header').addClass('go-away');
				} else {
					$('#site-header').removeClass('go-away');
				}

				lastScrollTop = st;
			}
		}
	});

	$(document).on('click','.mobile-menu__trigger',function(e){
		e.preventDefault();
		$(this).toggleClass('open');
		$('#mobile-menu').toggleClass('active');
	});
	
})(jQuery);